import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FormCategory, GlobalForm, Tag, TagSetting } from '../../../../core';
export var GlobalFormApiMapper = /*#__PURE__*/function () {
  function GlobalFormApiMapper() {
    _classCallCheck(this, GlobalFormApiMapper);
  }

  _createClass(GlobalFormApiMapper, [{
    key: "toDomain",
    value: function toDomain(globalFormDto) {
      var props = {
        id: globalFormDto.id,
        title: globalFormDto.title,
        description: globalFormDto.description,
        usageCount: globalFormDto.usageCount,
        updatedAt: globalFormDto.updatedAt,
        coverImage: globalFormDto.coverImage,
        thumbnail: globalFormDto.thumbnail,
        totalQuestions: globalFormDto.totalQuestions,
        totalScore: globalFormDto.totalScore
      };

      if (globalFormDto.category) {
        var _globalFormDto$catego, _globalFormDto$catego2;

        props.category = FormCategory.create({
          id: globalFormDto.category.id.toString(),
          key: globalFormDto.category.key,
          status: globalFormDto.category.status,
          possibleQuestionCreationTypes: globalFormDto.category.possibleQuestionCreationTypes,
          tagSettings: (_globalFormDto$catego = globalFormDto.category) === null || _globalFormDto$catego === void 0 ? void 0 : (_globalFormDto$catego2 = _globalFormDto$catego.tagSettings) === null || _globalFormDto$catego2 === void 0 ? void 0 : _globalFormDto$catego2.map(function (tag) {
            return TagSetting.create(_objectSpread({}, tag)).getValue();
          })
        }).getValue();
      }

      if (globalFormDto.tags) {
        props.tags = globalFormDto.tags.map(function (tag) {
          return tag && Tag.create({
            id: tag.id.toString(),
            key: tag.key,
            icon: tag.icon
          }).getValue();
        }).filter(function (tag) {
          return !!tag;
        });
      }

      return GlobalForm.create(props).getValue();
    }
  }]);

  return GlobalFormApiMapper;
}();